export const INDICATOR_UPDATE = 'indicator/UPDATE'
export type INDICATOR_UPDATE = typeof INDICATOR_UPDATE

export const INDICATOR_SELECT = 'indicator/SELECT'
export type INDICATOR_SELECT = typeof INDICATOR_SELECT

export const INDICATOR_VALUATION = 'indicator/VALUATION'
export type INDICATOR_VALUATION = typeof INDICATOR_VALUATION

export const INDICATOR_WEIGHT = 'indicator/WEIGHT'
export type INDICATOR_WEIGHT = typeof INDICATOR_WEIGHT

export const INDICATOR_GROUP_SELECTION = 'indicator/GROUP_SELECT'
export type INDICATOR_GROUP_SELECTION = typeof INDICATOR_GROUP_SELECTION

export const REPLACE_SELECTED_INDICATOR = 'indicator/REPLACE_SELECTED_INDICATOR'
export type REPLACE_SELECTED_INDICATOR = typeof REPLACE_SELECTED_INDICATOR
